import React, { useContext } from 'react';
import Context from "../context/context";
import NavItemMobile from './NavItemMobile';
import HiddenSearch from './HiddenSearch';


const FilterNavMobile = props => {
  const {clearAllFilters, toggleFilterNav} = props;
  const {filterNav, language} = useContext(Context);
  return (
    <>

      <div
        className="filter-nav-mobile"
        id="filter_navs"
      >
      <div className="filter-nav-mobile-label">Filter {language.type} by:</div>
      <div class="filter-nav-mobile-inner">
      <button
        className="filter-trigger-drag"
        id="scroll_handle"
        onClick={() => toggleFilterNav(false)}
      >
        <div className="drag-tab"></div>
        <div className="close-vertical-filters">
          Close
          <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 3.5L4 10.5" stroke="#182A38" stroke-width="2"></path><path d="M4 3.5L11 10.5" stroke="#182A38" stroke-width="2"></path></svg>
        </div>
      </button>
      {filterNav.map((widget, i) => {
        if (widget.type != "hidden" && widget.position != "top"  ) {

        return <NavItemMobile
                  key={i}
                  widget={widget}
                  toggleFilterNav={toggleFilterNav}
               />
          }
      })}

          {filterNav.map((widget, i) => {

            if (widget.position != "top" ) {
              if (widget.filters[0].type == "search") {
                return <Search key={i} data={widget.filters[0]}/>
              }
              else if (widget.filters[0].type == "hidden") {
                return <HiddenSearch key={i} data={widget.filters[0]} clearAllFilters={clearAllFilters}/>
              }
            }
          })}

      </div>
      </div>


    </>
  )
}

export default FilterNavMobile;
